import { GetMailEntriesInBetween } from './Helpers';
import { MailItemToggleType } from '../Types/SharedFunctions/SharedFunctionTypes';

// TODO check SelectedItems is needed over the ref
const MailItemToggle = (props: MailItemToggleType) => {
	if (props.shiftKeyDownRef.current && props.selectedItemsRef.current.length > 0 && !props.gridViewRef.current) {
		const startEl = document.querySelector(
			`[data-item-id="${props.selectedItemsRef.current[props.selectedItemsRef.current.length - 1]}"]`,
		);
		const endEl = document.querySelector(`[data-item-id="${props.selectedMailUuid}"]`);
		const parentEl = startEl?.parentElement || endEl?.parentElement;

		let inBetween: any = [];

		if (startEl !== endEl && startEl?.nextElementSibling && endEl) {
			const startIndex = Array.prototype.indexOf.call(parentEl?.children, startEl);
			const endIndex = Array.prototype.indexOf.call(parentEl?.children, endEl);
			inBetween = GetMailEntriesInBetween(
				startIndex > endIndex ? startEl.previousElementSibling : startEl.nextElementSibling,
				endEl,
				endIndex > startIndex,
			);
		}

		for (const mailUuid of inBetween) {
			props.toggleSelectedCallback(mailUuid);
		}
	} else {
		props.toggleSelectedCallback(props.selectedMailUuid);
	}
};

export { MailItemToggle };
